import { Component, Injector, OnDestroy, Signal } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import {
  DsButtonIntent,
  DsButtonVariants,
  DsModalColorVariant,
  DsModalService,
  DsTooltipPosition,
  HeadingLevelType,
  DsColors,
  DsGradients,
  Icons,
} from '@levelaccess/design-system';
import { NgbActiveOffcanvas } from '@ng-bootstrap/ng-bootstrap';
import { Subscription } from 'rxjs';
import { AiChatBaseComponent } from '../ai-chat-base/ai-chat-base.component';
import { AiChatDeleteService } from '../ai-chat-delete.service';
import { IChatSession } from '../../../../../shared/interfaces/ai-chat.interface';

@Component({
  selector: 'app-ai-chat-modal',
  templateUrl: './ai-chat-modal.component.html',
  styleUrls: ['./ai-chat-modal.component.scss'],
  standalone: false,
})
export class AiChatModalComponent extends AiChatBaseComponent implements OnDestroy {
  protected readonly DsModalColorVariant: typeof DsModalColorVariant = DsModalColorVariant;
  protected readonly DsColors: typeof DsColors = DsColors;
  protected readonly DsGradients: typeof DsGradients = DsGradients;
  protected readonly HeadingStyle: HeadingLevelType = 'h2';
  protected readonly Icons: typeof Icons = Icons;
  protected readonly DsButtonVariants: typeof DsButtonVariants = DsButtonVariants;
  protected readonly DsButtonIntent: typeof DsButtonIntent = DsButtonIntent;
  protected readonly DsTooltipPosition: typeof DsTooltipPosition = DsTooltipPosition;

  readonly showChatHistory: Signal<boolean>;

  private aiChatDeleteService: AiChatDeleteService;
  private deleteSubscription: Subscription = new Subscription();

  constructor(
    public modalService: DsModalService,
    public modal: NgbActiveOffcanvas,
    injector: Injector,
  ) {
    super(injector);
    this.aiChatDeleteService = this.injector.get(AiChatDeleteService);
    this.showChatHistory = toSignal(this.aiChatStateService.showChatHistory$, { initialValue: false });
  }

  public onNewChat(): void {
    this.startNewChat();
    this.aiChatStateService.hideChatHistory();
  }

  public onToggleChatHistory(): void {
    this.aiChatStateService.toggleChatHistory();
  }

  public onSessionSelected(session: IChatSession): void {
    this.loadSession(session.sessionId);
    this.aiChatStateService.hideChatHistory();
  }

  public onSessionDeleted(sessionId: string): void {
    if (sessionId === this.sessionId) {
      this.startNewChat();
    }
  }

  public onDeleteCurrentSession(): void {
    this.deleteSubscription.add(
      this.aiChatDeleteService.confirmAndDeleteSession(this.sessionId).subscribe({
        next: (): void => {
          this.startNewChat();
        },
      }),
    );
  }

  public override ngOnDestroy(): void {
    super.ngOnDestroy();
    this.deleteSubscription.unsubscribe();
  }
}
